import { render } from "./DeleteMultipleUserModal.vue?vue&type=template&id=3838a239&scoped=true"
import script from "./DeleteMultipleUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteMultipleUserModal.vue?vue&type=script&lang=js"

import "./DeleteMultipleUserModal.vue?vue&type=style&index=0&id=3838a239&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3838a239"]])

export default __exports__